/**
 * RefreshIcon — issue #438 visual system. Circular-arrow glyph for
 * reset/restart actions. Tree-shakable via direct import:
 *
 *   import { RefreshIcon } from './icons/RefreshIcon';
 *
 * Accepts `size` (default 20) and `className`. Omit `aria-label` to
 * mark the icon as decorative (`aria-hidden="true"` by default); supply
 * `aria-label` to render as a labelled image with `role="img"`.
 */
import type { ReactElement } from 'react';
import type { IconProps } from './iconTypes';
import { SHARED_ICON_ATTRS } from './iconTypes';

export function RefreshIcon({ size = 20, className, ...rest }: IconProps): ReactElement {
  const aria = rest['aria-label']
    ? { role: 'img' as const, 'aria-label': rest['aria-label'] }
    : { 'aria-hidden': true };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...SHARED_ICON_ATTRS}
      {...aria}
      {...className ? { className } : undefined}
      {...rest}
    >
      <path d="M23 4v6h-6" />
      <path d="M1 20v-6h6" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  );
}
